import { Combobox, Transition } from '@headlessui/react';
import { BuildingOfficeIcon } from '@heroicons/react/24/outline';
import React, { useState, Fragment } from 'react';
import { oktaOrgs } from '../lib/okta';
import { CheckIcon } from '@heroicons/react/20/solid';

const SsoLoginSelector = ({ handleOktaLogin }) => {
  const [selected, setSelected] = useState('');
  const [query, setQuery] = useState('');

  const filteredOrgs =
    query === ''
      ? oktaOrgs
      : oktaOrgs.filter((currOktaOrg) =>
          currOktaOrg.name
            .toLowerCase()
            .replace(/\s+/g, '')
            .includes(query.toLowerCase().replace(/\s+/g, ''))
        );

  return (
    <>
      <Combobox value={selected} onChange={setSelected}>
        <div className="relative mt-1">
          <div className="relative cursor-default overflow-hidden bg-white text-left sm:text-sm shadow-sm border-0 ring-1 ring-gray-300 rounded-md text-gray-500 text-sm w-full outline-none focus:outline-none focus:ring-2 focus:ring-indigo-200 placeholder:text-gray-400 leading-5 transition-all duration-200 ease-in-out">
            <Combobox.Input
              autoFocus
              className="pl-11 p-2 ring-0 w-full border-none text-sm leading-5 text-gray-900 focus:ring-0"
              displayValue={(oktaOrg) => oktaOrg.name}
              onChange={(event) => setQuery(event.target.value)}
              placeholder="Enter you organization's name"
            />
            <BuildingOfficeIcon className="pointer-events-none absolute top-2 left-3 h-5 w-5 stroke-gray-400" />
          </div>
          {query.length > 1 && (
            <Transition
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
              afterLeave={() => setQuery('')}
            >
              <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {filteredOrgs.length === 0 && query !== '' ? (
                  <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                    Nothing found.
                  </div>
                ) : (
                  filteredOrgs.map((oktaOrg) => (
                    <Combobox.Option
                      key={oktaOrg.orgID}
                      className={({ active }) =>
                        `relative cursor-default select-none py-2 pl-10 pr-4 ${
                          active ? 'bg-indigo-600 text-white' : 'text-gray-900'
                        }`
                      }
                      value={oktaOrg}
                    >
                      {({ selected, active }) => (
                        <>
                          <span
                            className={`block truncate ${
                              selected ? 'font-medium' : 'font-normal'
                            }`}
                          >
                            {oktaOrg.name}
                          </span>
                          {selected ? (
                            <span
                              className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                                active ? 'text-white' : 'text-indigo-600'
                              }`}
                            >
                              <CheckIcon
                                className="h-5 w-5"
                                aria-hidden="true"
                              />
                            </span>
                          ) : null}
                        </>
                      )}
                    </Combobox.Option>
                  ))
                )}
              </Combobox.Options>
            </Transition>
          )}
        </div>
      </Combobox>
      <button
        onClick={(event) => {
          event.preventDefault();
          handleOktaLogin(selected);
        }}
        class="mt-3 w-full flex justify-center py-2 px-4 border border-1 border-gray-300 transparent rounded-md ring-gray-400 shadow-sm text-sm text-gray-500 bg-white hover:bg-gray-100 active:scale-95 focus:outline-none transition-all duration-200 ease-in-out"
      >
        Sign in with SSO
      </button>
    </>
  );
};

export default SsoLoginSelector;
